import form_module_default from "./form.module.js";
import { InlineSpinner } from "../InlineSpinner/InlineSpinner.js";
import classNames from "classnames";
import { forwardRef } from "react";
import ErrorIcon from "@vector-im/compound-design-tokens/assets/web/icons/error-solid";
import { jsx, jsxs } from "react/jsx-runtime";
import { Message } from "@radix-ui/react-form";
import CheckCircleSolidIcon from "@vector-im/compound-design-tokens/assets/web/icons/check-circle-solid";
//#region src/components/Form/Message.tsx
/**
* An error message to display below a form control.
*/
var ErrorMessage = forwardRef(function ErrorMessage({ children, className, ...props }, ref) {
	const classes = classNames(form_module_default.message, form_module_default["error-message"], className);
	return /* @__PURE__ */ jsxs(Message, {
		ref,
		...props,
		className: classes,
		children: [/* @__PURE__ */ jsx(ErrorIcon, {}), children]
	});
});
/**
* A success message to display below a form control.
*/
var SuccessMessage = forwardRef(function SuccessMessage({ children, className, ...props }, ref) {
	const classes = classNames(form_module_default.message, form_module_default["success-message"], className);
	return /* @__PURE__ */ jsxs(Message, {
		ref,
		...props,
		className: classes,
		children: [/* @__PURE__ */ jsx(CheckCircleSolidIcon, {}), children]
	});
});
/**
* A message showing a loading state
*/
var LoadingMessage = forwardRef(function LoadingMessage({ children, className, ...props }, ref) {
	const classes = classNames(form_module_default.message, className);
	return /* @__PURE__ */ jsxs(Message, {
		ref,
		...props,
		className: classes,
		children: [/* @__PURE__ */ jsx(InlineSpinner, {}), children]
	});
});
/**
* A help message to display below a form control.
*/
var HelpMessage = forwardRef(function HelpMessage({ children, className, ...props }, ref) {
	const classes = classNames(form_module_default.message, form_module_default["help-message"], className);
	return /* @__PURE__ */ jsx(Message, {
		ref,
		...props,
		className: classes,
		children
	});
});
//#endregion
export { ErrorMessage, HelpMessage, LoadingMessage, SuccessMessage };

//# sourceMappingURL=Message.js.map